import { useEffect, useState } from "react";
import { server } from "../../server";
import Select from "react-select";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  bloodGroupList,
  categoryList,
  certificatesList,
  classList,
  houseList,
  monthsList,
  relationshipsList,
  religionList,
  sectionList,
  statesList,
  subjectList,
} from "../../utils";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

function UpdateStudent() {
  const MySwal = withReactContent(Swal);
  const [error, setError] = useState(null);
  const { state } = useLocation();
  const admissionNo = state?.admissionNo;
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [studentData, setStudentData] = useState(null);
  const [subjectSelections, setSubjectSelections] = useState(
    Array(8).fill(""),
  );

  const handleLeftStudentClick = async () => {
    const result = await MySwal.fire({
      title: "Mark as Left?",
      text: `Are you sure you want to mark this student as left?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Mark as Left!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        await axios.post(
          `${server}/add_student_to_leftStudent_mongodb`,
          { admission_no: admissionNo },
          { headers: { Authorization: `${localStorage.getItem("token")}` } },
        );
        toast.success("Student Marked as Left", { position: "top-right" });
        navigate("/student-details");
      } catch (error) {
        toast.error("Please Try Again", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDisabledStudentClick = async () => {
    const result = await MySwal.fire({
      title: "Disable Student?",
      text: `Are you sure you want to disable this student?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Disable!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);
        await axios.post(
          `${server}/add_student_to_disabledStudent_mongodb`,
          { admission_no: admissionNo },
          { headers: { Authorization: `${localStorage.getItem("token")}` } },
        );
        toast.success("Student Marked as Disabled", { position: "top-right" });
        navigate("/student-details");
      } catch (error) {
        toast.error("Please Try Again", { position: "top-right" });
      } finally {
        setLoading(false);
      }
    }
  };

  const [formData, setFormData] = useState({
    currentClass: "",
    session: "2025-26",
    studentDetails: {
      studentId: "",
      admission_no: "",
      admissionDate: "",
      name: "",
      admissionInClass: "",
      admissionInSection: "",
      currentSection: "",
      rollNo: "",
      gender: "",
      dateOfBirth: "",
      category: "",
      house: "",
      aadhar_no: "",
      apaarId: "",
      pen: "",
      religion: "",
      bloodGroup: "",
      handicap: "",
      previousSchoolName: "",
      previousSchoolAddress: "",
      underMidSection: "",
      applicableMonth: "",
      phoneNo: "",
      studentImage: "",
    },
    parentDetails: [
      {
        name: "",
        qualification: "",
        occupation: "",
        phone: "",
        email: "",
        Income: "",
        relation: "Father",
      },
      {
        name: "",
        qualification: "",
        occupation: "",
        phone: "",
        email: "",
        Income: "",
        relation: "Mother",
      },
      {
        name: "",
        phone: "",
        aadhaarNo: "",
        relation: "Guardian",
      },
      {
        name: "",
        phone: "",
        aadhaarNo: "",
        relation: "Emergency Guardian",
      },
    ],
    presentAddress: {
      address: "",
      city: "",
      pincode: "",
      state: "",
    },
    permanentAddress: {
      address: "",
      city: "",
      pincode: "",
      state: "",
    },
    certificate: [],
    subjects: [],
  });

  useEffect(() => {
    const fetchStudent = async () => {
      if (!admissionNo) {
        setError("Please enter Admission No");
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const response = await axios.post(
          `${server}/getParticularStudentMongodb`,
          { admission_no: admissionNo },
          {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        const studentData = response.data?.["body-json"]?.body?.student;
        if (studentData) {
          setStudentData(studentData);
        } else {
          setError("No Student Data Found");
          setStudentData(null);
        }
      } catch (err) {
        setError("Student not found or API error.");
        setStudentData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [admissionNo]);

  useEffect(() => {
    if (studentData) {
      setFormData((prev) => ({
        ...prev,
        currentClass: studentData.currentClass,
        studentDetails: {
          ...prev.studentDetails,
          ...studentData.studentDetails,
          studentImage:
            prev.studentDetails.studentImage ||
            studentData.studentDetails.studentImage,
        },
        parentDetails: studentData.parentDetails || prev.parentDetails,
        presentAddress: studentData.presentAddress || prev.presentAddress,
        permanentAddress: studentData.permanentAddress || prev.permanentAddress,
        certificate: studentData.certificate,
      }));

      if (Array.isArray(studentData.subjects)) {
        const initialSubjects = Array(8).fill("");
        studentData.subjects.forEach((subject, index) => {
          if (index < 8) initialSubjects[index] = subject;
        });
        setSubjectSelections(initialSubjects);
      }
    }
  }, [studentData]);

  useEffect(() => {
    if (image) {
      setFormData((prev) => ({
        ...prev,
        studentDetails: {
          ...prev.studentDetails,
          studentImage: image,
        },
      }));
    }
  }, [image]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isSameAddress, setIsSameAddress] = useState(false);

  const handleChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleStudentDetailsChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      studentDetails: {
        ...prev.studentDetails,
        [name]: value,
      },
    }));
  };

  const handleParentDetailsChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevForm) => {
      const updatedParentDetails = [...prevForm.parentDetails];
      updatedParentDetails[index] = {
        ...updatedParentDetails[index],
        [name]: value,
      };
      return { ...prevForm, parentDetails: updatedParentDetails };
    });
  };

  const handlePresentAddressChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedPresentAddress = {
        ...prev.presentAddress,
        [name]: value,
      };

      const updatedPermanentAddress = isSameAddress
        ? { ...updatedPresentAddress }
        : prev.permanentAddress;

      return {
        ...prev,
        presentAddress: updatedPresentAddress,
        permanentAddress: updatedPermanentAddress,
      };
    });
  };

  const handlePermanentAddressChange = (e) => {
    if (isSameAddress) return;

    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      permanentAddress: {
        ...prev.permanentAddress,
        [name]: value,
      },
    }));
  };

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsSameAddress(checked);

    setFormData((prev) => ({
      ...prev,
      permanentAddress: checked
        ? { ...prev.presentAddress }
        : { address: "", city: "", pincode: "", state: "" },
    }));
  };

  const handleCertificateChange = (item) => {
    setFormData((prevData) => {
      const isSelected = prevData.certificate.includes(item);

      return {
        ...prevData,
        certificate: isSelected
          ? prevData.certificate.filter((cert) => cert !== item)
          : [...prevData.certificate, item],
      };
    });
  };

  // ── Subjects (8 independent selects, none required) ─────────────────────
  const handleSubjectSelectChange = (index, selected) => {
    setSubjectSelections((prev) => {
      const updated = [...prev];
      updated[index] = selected?.value || "";
      return updated;
    });
  };

  useEffect(() => {
    const filteredSubjects = subjectSelections.filter(
      (subject) => subject && subject !== "",
    );
    setFormData((prev) => ({
      ...prev,
      subjects: filteredSubjects,
    }));
  }, [subjectSelections]);

  const countAddressFilledFields = (obj1, obj2) => {
    return String(
      [...Object.values(obj1), ...Object.values(obj2)].filter(
        (value) => value !== "",
      ).length,
    ).padStart(2, "0");
  };

  const getAddressTotalFields = (obj1, obj2) => {
    return String(Object.keys(obj1).length + Object.keys(obj2).length).padStart(
      2,
      "0",
    );
  };

  const countFilledFields = (obj) => {
    return String(
      Object.values(obj).filter((value) => value !== "").length,
    ).padStart(2, "0");
  };

  const getTotalFields = (obj) => {
    return String(Object.keys(obj).length).padStart(2, "0");
  };

  const countParentFilledFields = (arr) => {
    return String(
      arr.reduce((count, obj) => {
        return (
          count + Object.values(obj).filter((value) => value !== "").length
        );
      }, 0),
    ).padStart(2, "0");
  };

  const getParentTotalFields = (arr) => {
    return String(
      arr.reduce((count, obj) => count + Object.keys(obj).length, 0),
    ).padStart(2, "0");
  };

  const countFilled = countParentFilledFields(formData.parentDetails);
  const totalFields = getParentTotalFields(formData.parentDetails);
  const isCompleted = countFilled === totalFields;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (uploading) {
      toast.warn("Please Wait, Uploading Image", {
        position: "top-right",
      });
      return;
    }

    let newErrors = {};
    setLoading(true);

    try {
      const response = await axios.post(
        `${server}/updateStudentsMongoDb`,
        { ...formData, admission_no: admissionNo },
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );
      toast.success("Student Details Updated", { position: "top-right" });
      navigate("/student-details");
      setFormData(formData);
    } catch (error) {
      toast.error("Please Try Again", { position: "top-right" });
    } finally {
      setLoading(false);
      return;
    }
  };

  const handleUploadStudentImage = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploading(true);
    setPreview(URL.createObjectURL(file));

    try {
      const { data } = await axios.post(`${server}/studentImagePresigned`, {
        fileName: file.name,
      });

      const uploadDetails = data?.["body-json"]?.body?.uploadDetails?.[0];
      const signedUrl = uploadDetails?.signedUrl;
      const key = uploadDetails?.key;

      const baseUrl = signedUrl?.split("?")[0];
      const fullImageUrl = baseUrl;

      await axios.put(signedUrl, file, {
        headers: { "Content-Type": file.type },
      });

      setImage(fullImageUrl);
      setFormData((prev) => ({
        ...prev,
        studentDetails: {
          ...prev.studentDetails,
          studentImage: fullImageUrl,
        },
      }));
    } catch (error) {
      toast.error("Image Upload Failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <div id="db-wrapper">
        <main id="page-content">
          <div className="">
            <div class="container-fluid">
              <div class="row">
                <div class="col-lg-12 col-md-12 col-12">
                  <div class="m-3 mt-2 pt-1 d-flex justify-content-between">
                    <div class="d-flex align-items-center mt-2">
                      <span
                        onClick={() => window.history.back()}
                        class="back-button me-3 cursor-pointer"
                      >
                        <i className="bi bi-arrow-left fs-3"></i>
                      </span>
                      <nav aria-label="breadcrumb">
                        <h4 className="m-0 lh-sm">Update Student</h4>
                        <ol class="breadcrumb pe-3 lh-sm">
                          <li class="breadcrumb-item">
                            <a href="#">Student Information</a>
                          </li>
                          <li class="breadcrumb-item">
                            <a href="#">Student Details</a>
                          </li>
                          <li
                            class="breadcrumb-item active"
                            aria-current="page"
                          >
                            Update Student
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="container-fluid">
              <div className="row g-2">
                <div className="col-lg-8">
                  <form onSubmit={handleSubmit}>
                    <div class="px-5 py-3 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingOne">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              <span class="me-auto fs-5">
                                1. Student Details{" "}
                                <span className="ms-3 text-secondary">
                                  ({countFilledFields(formData.studentDetails)}/
                                  {getTotalFields(formData.studentDetails)})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span
                                  className={`badge me-5 px-3 ${
                                    countFilledFields(
                                      formData.studentDetails,
                                    ) ===
                                    getTotalFields(formData.studentDetails)
                                      ? "bg-success-soft"
                                      : "bg-danger-soft"
                                  }`}
                                >
                                  {countFilledFields(
                                    formData.studentDetails,
                                  ) === getTotalFields(formData.studentDetails)
                                    ? "Completed"
                                    : "Required"}
                                </span>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseOne"
                            class="collapse"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Student Id
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.studentId
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="studentId"
                                  placeholder="..."
                                  value={formData.studentDetails?.studentId}
                                  onChange={handleStudentDetailsChange}
                                  required
                                  readOnly
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Admission Number{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.admission_no
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="admission_no"
                                  placeholder="..."
                                  value={formData.studentDetails?.admission_no}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Admission Date{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.admissionDate
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="admissionDate"
                                  placeholder="..."
                                  value={formData.studentDetails?.admissionDate}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Full Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.name
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="name"
                                  placeholder="..."
                                  value={formData.studentDetails?.name}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Admission in Class{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.admissionInClass
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="admissionInClass"
                                  value={
                                    formData.studentDetails?.admissionInClass
                                  }
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  {classList.map((className, index) => (
                                    <option key={index} value={className}>
                                      {className}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Section <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.admissionInSection
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="admissionInSection"
                                  value={
                                    formData.studentDetails?.admissionInSection
                                  }
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  {sectionList.map((sectionName, index) => (
                                    <option key={index} value={sectionName}>
                                      {sectionName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Current Class{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.currentClass ? "border-danger" : ""
                                  }`}
                                  name="currentClass"
                                  value={formData.currentClass}
                                  onChange={handleChange}
                                >
                                  <option value="">...</option>
                                  {classList.map((className, index) => (
                                    <option key={index} value={className}>
                                      {className}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Section <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.currentSection
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="currentSection"
                                  value={
                                    formData.studentDetails?.currentSection
                                  }
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  {sectionList.map((sectionName, index) => (
                                    <option key={index} value={sectionName}>
                                      {sectionName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Roll No.
                                </label>
                                <input
                                  type="number"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.rollNo
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="rollNo"
                                  placeholder="..."
                                  value={formData.studentDetails?.rollNo}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Select Gender{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.gender
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="gender"
                                  value={formData.studentDetails?.gender}
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Date of Birth{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="date"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.dateOfBirth
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="dateOfBirth"
                                  placeholder="..."
                                  value={formData.studentDetails?.dateOfBirth}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Category{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.category
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="category"
                                  value={formData.studentDetails?.category}
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  {categoryList.map((categoryName, index) => (
                                    <option key={index} value={categoryName}>
                                      {categoryName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  House <span className="text-danger">*</span>
                                </label>
                                <Select
                                  options={houseList.map((house) => ({
                                    label: house,
                                    value: house.toLowerCase(),
                                  }))}
                                  value={
                                    houseList
                                      .map((house) => ({
                                        label: house,
                                        value: house.toLowerCase(),
                                      }))
                                      .find(
                                        (opt) =>
                                          opt.value ===
                                          (
                                            formData.studentDetails?.house || ""
                                          ).toLowerCase(),
                                      ) || null
                                  }
                                  onChange={(selected) =>
                                    setFormData((prev) => ({
                                      ...prev,
                                      studentDetails: {
                                        ...prev.studentDetails,
                                        house: selected?.label || "",
                                      },
                                    }))
                                  }
                                  placeholder="Select House"
                                  classNamePrefix="react-select"
                                  className={`text-dark ${
                                    errors?.studentDetails?.house
                                      ? "border-danger"
                                      : ""
                                  }`}
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Blood Group{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.bloodGroup
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="bloodGroup"
                                  value={formData.studentDetails?.bloodGroup}
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  {bloodGroupList.map(
                                    (bloodGroupName, index) => (
                                      <option
                                        key={index}
                                        value={bloodGroupName}
                                      >
                                        {bloodGroupName}
                                      </option>
                                    ),
                                  )}
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Aadhaar No{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.aadhar_no
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="aadhar_no"
                                  placeholder="..."
                                  value={formData.studentDetails?.aadhar_no}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Apaar ID{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  maxLength={12}
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.apaarId
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="apaarId"
                                  placeholder="..."
                                  value={formData.studentDetails?.apaarId || ""}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  PEN <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  maxLength={12}
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.pen
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="pen"
                                  placeholder="..."
                                  value={formData.studentDetails?.pen || ""}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Religion{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.religion
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="religion"
                                  value={formData.studentDetails?.religion}
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  {religionList.map((religionName, index) => (
                                    <option key={index} value={religionName}>
                                      {religionName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Handicap{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.handicap
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="handicap"
                                  value={formData.studentDetails?.handicap}
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  <option value="No">No</option>
                                  <option value="Yes">Yes</option>
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Previous School Name{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.previousSchoolName
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="previousSchoolName"
                                  placeholder="..."
                                  value={
                                    formData.studentDetails?.previousSchoolName
                                  }
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Previous School Address{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails
                                      ?.previousSchoolAddress
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="previousSchoolAddress"
                                  placeholder="..."
                                  value={
                                    formData.studentDetails
                                      ?.previousSchoolAddress
                                  }
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>

                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Under Mid Session{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.underMidSection
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="underMidSection"
                                  value={
                                    formData.studentDetails?.underMidSection
                                  }
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  <option value="No">No</option>
                                  <option value="Yes">Yes</option>
                                </select>
                              </div>
                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Applicable Month{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <select
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.applicableMonth
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="applicableMonth"
                                  value={
                                    formData.studentDetails?.applicableMonth
                                  }
                                  onChange={handleStudentDetailsChange}
                                >
                                  <option value="">...</option>
                                  {monthsList.map((monthsName, index) => (
                                    <option key={index} value={monthsName}>
                                      {monthsName}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-lg-6 col-12">
                                <label class="form-label mb-1 ms-3">
                                  Primary Phone No.{" "}
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control text-dark ${
                                    errors?.studentDetails?.phoneNo
                                      ? "border-danger"
                                      : ""
                                  }`}
                                  name="phoneNo"
                                  placeholder="..."
                                  value={formData.studentDetails?.phoneNo}
                                  onChange={handleStudentDetailsChange}
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingTwo">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                            >
                              <span class="me-auto fs-5">
                                2. Parent Details{" "}
                                <span className="ms-3 text-secondary">
                                  ({countFilled}/{totalFields})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span
                                  className={`badge me-5 px-3 ${
                                    isCompleted
                                      ? "bg-success-soft"
                                      : "bg-danger-soft"
                                  }`}
                                >
                                  {isCompleted ? "Completed" : "Required"}
                                </span>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseTwo"
                            class="collapse"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mb-3">
                              {formData.parentDetails.map((parent, index) => (
                                <div key={index} className="col-lg-6 col-12">
                                  <p className="px-4 py-3 bg-light rounded-3 text-dark mt-3 mb-1 lh-sm">
                                    {parent.relation}'s Details
                                    <br />
                                    <span className="text-secondary">
                                      (All Details are Compulsory)
                                    </span>
                                  </p>
                                  <div className="row g-3 mb-2">
                                    <div className="col-12">
                                      {index <= 1 ? (
                                        ""
                                      ) : (
                                        <>
                                          <label className="form-label mb-1 ms-3 mt-3">
                                            Relation with Student{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <select
                                            className="form-control"
                                            name="relation"
                                            value={parent.relation}
                                            onChange={(e) =>
                                              handleParentDetailsChange(
                                                index,
                                                e,
                                              )
                                            }
                                          >
                                            {relationshipsList.map(
                                              (relation, index) => (
                                                <option
                                                  key={index}
                                                  value={relation}
                                                >
                                                  {relation}
                                                </option>
                                              ),
                                            )}
                                          </select>
                                        </>
                                      )}
                                    </div>

                                    {Object.keys(parent).map((key) => {
                                      if (key === "relation") return null;
                                      return (
                                        <div key={key} className="col-12">
                                          <label className="form-label mb-1 ms-3">
                                            {key.charAt(0).toUpperCase() +
                                              key.slice(1)}{" "}
                                            <span className="text-danger">
                                              *
                                            </span>
                                          </label>
                                          <input
                                            type="text"
                                            className={`form-control text-dark ${
                                              errors?.parentDetails?.[index]?.[
                                                key
                                              ]
                                                ? "border-danger"
                                                : ""
                                            }`}
                                            name={key}
                                            value={parent[key] || ""}
                                            onChange={(e) =>
                                              handleParentDetailsChange(
                                                index,
                                                e,
                                              )
                                            }
                                            required
                                          />
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingThree">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseThree"
                              aria-controls="collapseThree"
                            >
                              <span class="me-auto fs-5">
                                3. Address{" "}
                                <span className="ms-3 text-secondary">
                                  (
                                  {countAddressFilledFields(
                                    formData.presentAddress,
                                    formData.permanentAddress,
                                  )}
                                  /
                                  {getAddressTotalFields(
                                    formData.presentAddress,
                                    formData.permanentAddress,
                                  )}
                                  )
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span
                                  className={`badge me-5 px-3 ${
                                    countAddressFilledFields(
                                      formData.presentAddress,
                                      formData.permanentAddress,
                                    ) ===
                                    getAddressTotalFields(
                                      formData.presentAddress,
                                      formData.permanentAddress,
                                    )
                                      ? "bg-success-soft"
                                      : "bg-danger-soft"
                                  }`}
                                >
                                  {countAddressFilledFields(
                                    formData.presentAddress,
                                    formData.permanentAddress,
                                  ) ===
                                  getAddressTotalFields(
                                    formData.presentAddress,
                                    formData.permanentAddress,
                                  )
                                    ? "Completed"
                                    : "Required"}
                                </span>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseThree"
                            class="collapse"
                            aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 my-3">
                              <div className="col-lg-6 col-12">
                                <p className="px-4 py-3 bg-light rounded-3 text-dark mb-3 lh-sm">
                                  Present Address
                                  <br />
                                  <span className="text-secondary">
                                    (All Details are Compulsory)
                                  </span>
                                </p>
                                <div className="">
                                  <div className="row g-3 mb-2">
                                    <div className="col-12">
                                      <label class="form-label mb-1 ms-3">
                                        Address
                                        <span className="text-danger">*</span>
                                      </label>
                                      <textarea
                                        type="text"
                                        className={`form-control text-dark ${
                                          errors?.presentAddress?.address
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="address"
                                        value={formData.presentAddress.address}
                                        onChange={handlePresentAddressChange}
                                        placeholder="..."
                                        rows="3"
                                        required
                                      />
                                    </div>
                                    <div className="col-12">
                                      <label class="form-label mb-1 ms-3">
                                        State
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className={`form-control text-dark ${
                                          errors?.presentAddress?.state
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="state"
                                        value={formData.presentAddress.state}
                                        onChange={handlePresentAddressChange}
                                        required
                                      >
                                        <option value="">...</option>
                                        {statesList.map((state, index) => (
                                          <option key={index} value={state}>
                                            {state}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className="col-12">
                                      <label class="form-label mb-1 ms-3">
                                        City
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className={`form-control text-dark ${
                                          errors?.presentAddress?.city
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="city"
                                        value={formData.presentAddress.city}
                                        onChange={handlePresentAddressChange}
                                        placeholder="..."
                                        required
                                      />
                                    </div>
                                    <div className="col-12">
                                      <label class="form-label mb-1 ms-3">
                                        Pincode
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className={`form-control text-dark ${
                                          errors?.presentAddress?.pincode
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="pincode"
                                        value={formData.presentAddress.pincode}
                                        onChange={handlePresentAddressChange}
                                        placeholder="..."
                                        required
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6 col-12">
                                <div className="px-4 py-3 bg-light rounded-3 mb-3 d-flex align-items-center justify-content-between">
                                  <p className="text-dark lh-sm m-0">
                                    Permanent Address
                                    <br />
                                    <span className="text-secondary">
                                      (Same as Present Address)
                                    </span>
                                  </p>
                                  <div className="d-flex">
                                    <input
                                      type="checkbox"
                                      className="form-check-input ms-3"
                                      checked={isSameAddress}
                                      onChange={handleCheckboxChange}
                                    />
                                  </div>
                                </div>
                                <div className="">
                                  <div className="row g-2">
                                    <div className="col-12">
                                      <label class="form-label mb-1 ms-3">
                                        Address
                                        <span className="text-danger">*</span>
                                      </label>
                                      <textarea
                                        type="text"
                                        className={`form-control text-dark ${
                                          errors?.permanentAddress?.address
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="address"
                                        value={
                                          formData.permanentAddress.address
                                        }
                                        onChange={handlePermanentAddressChange}
                                        placeholder="..."
                                        rows="3"
                                        required
                                      />
                                    </div>
                                    <div className="col-12">
                                      <label class="form-label mb-1 ms-3">
                                        State
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className={`form-control text-dark ${
                                          errors?.permanentAddress?.state
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="state"
                                        value={formData.permanentAddress.state}
                                        onChange={handlePermanentAddressChange}
                                      >
                                        <option value="">...</option>
                                        {statesList.map((state, index) => (
                                          <option key={index} value={state}>
                                            {state}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className="col-12">
                                      <label class="form-label mb-1 ms-3">
                                        City
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className={`form-control text-dark ${
                                          errors?.permanentAddress?.city
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="city"
                                        value={formData.permanentAddress.city}
                                        onChange={handlePermanentAddressChange}
                                        placeholder="..."
                                        required
                                      />
                                    </div>
                                    <div className="col-12">
                                      <label class="form-label mb-1 ms-3">
                                        Pincode
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className={`form-control text-dark ${
                                          errors?.permanentAddress?.pincode
                                            ? "border-danger"
                                            : ""
                                        }`}
                                        name="pincode"
                                        value={
                                          formData.permanentAddress.pincode
                                        }
                                        onChange={handlePermanentAddressChange}
                                        placeholder="..."
                                        required
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingFive">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseFive"
                              aria-controls="collapseFive"
                            >
                              <span class="me-auto fs-5">
                                4. Certificate{" "}
                                <span className="ms-3 text-secondary">
                                  ({countFilledFields(formData.certificate)}/
                                  {certificatesList.length})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span
                                  className={`badge me-5 px-3 ${
                                    countFilledFields(formData.certificate) >= 5
                                      ? "bg-success-soft"
                                      : "bg-danger-soft"
                                  }`}
                                >
                                  {countFilledFields(formData.certificate) >= 5
                                    ? "Completed"
                                    : "Required"}
                                </span>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseFive"
                            class="collapse"
                            aria-labelledby="headingFive"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-3 py-2">
                              <div className="col-12 pt-1">
                                {certificatesList.map((item, index) => (
                                  <li
                                    className={`list-group-item d-flex align-items-center justify-content-between px-0 py-2 ${
                                      index === certificatesList.length - 1
                                        ? ""
                                        : "border-bottom"
                                    }`}
                                    key={index}
                                  >
                                    <div>
                                      {index + 1}. {item}
                                    </div>
                                    <div>
                                      <div className="form-check form-switch">
                                        <input
                                          type="checkbox"
                                          className="form-check-input mx-0"
                                          checked={formData.certificate.includes(
                                            item,
                                          )}
                                          onChange={() =>
                                            handleCertificateChange(item)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="px-5 py-3 mt-1 bg-white rounded-4">
                      <div
                        class="accordion accordion-flush"
                        id="accordionExample"
                      >
                        <div id="headingSix">
                          <h3 class="m-0 fs-list">
                            <a
                              href="#"
                              class="d-flex align-items-center text-inherit"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseSix"
                              aria-controls="collapseSix"
                            >
                              <span class="me-auto fs-5">
                                5. Subjects{" "}
                                <span className="ms-3 text-secondary">
                                  ({countFilledFields(subjectSelections)}/
                                  {getTotalFields(subjectSelections)})
                                </span>
                              </span>
                              <div className="d-flex align-items-center">
                                <span className="badge me-5 px-3 bg-info-soft">
                                  Optional
                                </span>
                                <span className="collapse-toggle">
                                  <i class="bi bi-chevron-down"></i>
                                </span>
                              </div>
                            </a>
                          </h3>

                          <div
                            id="collapseSix"
                            class="collapse"
                            aria-labelledby="headingSix"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="row g-2 mt-2 mb-3">
                              {subjectSelections.map((subjectValue, index) => (
                                <div className="col-lg-6 col-12" key={index}>
                                  <label class="form-label mb-1 ms-3">
                                    Subject {index + 1}
                                  </label>
                                  <Select
                                    options={subjectList.map((subject) => ({
                                      label: subject,
                                      value: subject,
                                    }))}
                                    value={
                                      subjectValue
                                        ? {
                                            label: subjectValue,
                                            value: subjectValue,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      handleSubjectSelectChange(
                                        index,
                                        selected,
                                      )
                                    }
                                    placeholder={`Select Subject ${
                                      index + 1
                                    }`}
                                    classNamePrefix="react-select"
                                    className="text-dark"
                                    isClearable
                                  />
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="my-3 d-flex float-end me-5">
                      <button
                        type="submit"
                        disabled={loading || uploading}
                        class="btn btn-success mt-2 px-6"
                      >
                        {loading ? (
                          <div
                            class="spinner-border spinner-border-sm"
                            role="status"
                          ></div>
                        ) : (
                          "Update"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
                <div className="col-lg-4">
                  {studentData && (
                    <div className="sticky-top top-10 z-1 ">
                      <div className="p-5 bg-white rounded-4">
                        <div className="d-flex flex-column align-items-center">
                          <div>
                            <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative overflow-hidden me-2">
                              {preview ||
                              studentData?.studentDetails?.studentImage ? (
                                <img
                                  src={
                                    preview ||
                                    studentData?.studentDetails?.studentImage
                                  }
                                  alt="Preview"
                                  width="150"
                                  height="150"
                                  className="object-fit-cover rounded-3"
                                />
                              ) : (
                                <span className="position-absolute mt-2">
                                  <i className="bi bi-image fs-2"></i>
                                </span>
                              )}

                              {uploading && (
                                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-50 rounded-3">
                                  <div
                                    className="spinner-border text-light"
                                    role="status"
                                  ></div>
                                </div>
                              )}

                              <input
                                className="form-control border-0 opacity-0 position-absolute top-0 start-0 w-100 h-100"
                                type="file"
                                onChange={handleUploadStudentImage}
                                accept="image/*"
                                disabled={uploading}
                              />
                            </div>
                            <div class="icon-shape icon-xxl p-7 border rounded-3 position-relative">
                              <img
                                src="https://cdn-icons-png.flaticon.com/512/14021/14021384.png"
                                className="w-100 position-absolute p-2 rounded-4"
                                alt="QR"
                              />
                            </div>
                          </div>
                          <div className="mt-3 text-center">
                            <h3 class="m-0 fs-4 lh-sm">
                              {studentData?.studentDetails?.name
                                .toLowerCase()
                                .replace(/\b\w/g, (char) =>
                                  char.toUpperCase(),
                                )}{" "}
                              ({studentData?.currentClass},{" "}
                              {studentData?.studentDetails?.currentSection})
                            </h3>
                            <p className="m-0">
                              {studentData?.studentDetails?.admission_no},{" "}
                              {new Date(
                                studentData?.studentDetails?.admissionDate,
                              ).toLocaleDateString("en-GB")}
                            </p>
                            <p className="mt-3 mb-0 text-danger lh-sm">
                              (+91) {studentData?.parentDetails[0]?.phone}
                              <br />
                              <span className="text-lowercase">
                                {studentData?.parentDetails[0]?.email}
                              </span>
                            </p>

                            <div className="mt-4">
                              <span
                                className="btn btn-danger btn-sm px-4 rounded-3 px-3 me-1 fw-normal"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!loading) handleDisabledStudentClick();
                                }}
                              >
                                Disabled Student
                              </span>

                              <span
                                className="btn btn-warning btn-sm px-4 rounded-3 fw-normal"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!loading) handleLeftStudentClick();
                                }}
                              >
                                Left Student
                              </span>
                            </div>

                            <p className="m-0 lh-sm mt-4 text-capitalize">
                              {studentData?.presentAddress?.address
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                              <br />
                              {studentData?.presentAddress?.city} -{" "}
                              {studentData?.presentAddress?.state}
                            </p>
                            <p className="mt-3 mb-0 text-dark lh-sm">
                              Mr.{" "}
                              {studentData?.parentDetails[0]?.name
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                              <br />
                              Mrs.{" "}
                              {studentData?.parentDetails[1]?.name
                                .toLowerCase()
                                .replace(/\b\w/g, (char) => char.toUpperCase())}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
}

export default UpdateStudent;